import React, { useEffect } from 'react';
import Loading from '../../components/Loading';

const LogoutPage = (props) => {
	useEffect(() =>  {
		props.logout();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return <Loading />;
};

export default LogoutPage;
